import * as Yup from 'yup';

export const staffValidationSchema = Yup.object().shape({
    name: Yup.string().required('Staff Name is required'),
    contactNumber: Yup.string()
        .matches(/^[0-9]{10}$/, 'Phone number must be 10 digits')
        .required('Phone Number is required'),
    dateOfBirthEpochMillis: Yup.date()
        .transform((value, originalValue) => {
            if (!originalValue || originalValue <= 0) return null;
            const timestamp = Number(originalValue);
            return timestamp < 0 ? null : new Date(timestamp);
        })
        .typeError('Invalid date format')
        .max(new Date(), 'Date of Birth cannot be in the future')
        .required('Date of Birth is required'),
    joiningDateEpochMillis: Yup.date()
        .transform((value, originalValue) => {
            return originalValue ? new Date(Number(originalValue)) : null;
        })
        .typeError('Invalid date format')
        .required('Date of Join is required'),
    staffTypeId: Yup.string().required('Staff Type is required'),
    vehicleTypeId: Yup.number().required('Vehicle Type is required'),
    vehicleNumber: Yup.string().when('vehicleTypeId', {
        is: (vehicleTypeId) => !!vehicleTypeId?.vehicleNumberMandatory,
        then: () => Yup.string().required('Vehicle Number is required'),
        otherwise: () => Yup.string(),
    }),
    selfieEnabled: Yup.boolean(),
    trackAndTraceEnabled: Yup.boolean(),
    geofenceAutoApproval: Yup.boolean(),
    hubId: Yup.string(),
    shiftTimingIds: Yup.array()
        .min(1, 'At least one shift timing must be selected')
        .required('Shift Timing is required'),
    zones: Yup.array(),
    trainingCompleted: Yup.boolean(),
    freelancer: Yup.boolean(),
    salaryType: Yup.string().required('Salary Type is required').default('4'),
    salaryCycle: Yup.string(),
    salaryCycleDay: Yup.string().when('salaryCycle', {
        is: 'monthly',
        then: Yup.string().required('Salary Cycle Day is required'),
    }),
    baseRate: Yup.number(),
    baseRateType: Yup.string(),
    openingBalance: Yup.number(),
    staffCustCode: Yup.string(),
    vendorId: Yup.string(),
    customerId: Yup.string(),
    clients: Yup.array().of(
        Yup.object().shape({
            customerId: Yup.string().required('Client is required'),
            staffCustCode: Yup.string().required(
                'Staff Customer Code is required',
            ),
        }),
    ),
    userCreationSource: Yup.string(),
    userCreationSourceId: Yup.string(),
    sourceRemarks: Yup.string(),
});
